import {teamMember} from "../../data/models";
import {linkedItem, platform} from "./models";
import {showErrorNotification, showSuccessNotification} from "../../global/notifications";

let employeeSelectsInit = false;
let branchManagerEmployeeSelectsInit = false;
let opsManagerGsmEmployeeSelectsInit = false;
let projectManagerEmployeeSelectsInit = false;
let linkableItemSelectsInit = false;
let platformUsedInit = false;

const id = $('[name="Id"]').val();
let attendeeTemplate;
let prfId = $('[name="Prf\\.Id"]').val();
let prfType = $('[name="Prf\\.Type"]').val();

const employeeDataSource = new kendo.data.DataSource({
    transport: {
        read: {
            url: '/Data/User/TeamMembers',
            dataType: 'json'
        }
    },
    schema: {
        model: teamMember
    }
});

const branchManagerDataSource = new kendo.data.DataSource({
    transport: {
        read: {
            url: '/Data/User/BranchManagers',
            dataType: 'json'
        },
        parameterMap(data, type) {
            if (type === 'read') {
                data.company = $('[name="Company"]').val()
            }
            console.debug(data);
            return data;
        }
    },
    schema: {
        model: teamMember
    }
});

const opsManagerGsmDataSource = new kendo.data.DataSource({
    transport: {
        read: {
            url: '/Data/User/OpsManager',
            dataType: 'json'
        },
        parameterMap(data, type) {
            if (type === 'read') {
                data.company = $('[name="Company"]').val()
            }
            console.debug(data);
            return data;
        }
    },
    schema: {
        model: teamMember
    }
});

const projectManagerDataSource = new kendo.data.DataSource({
    transport: {
        read: {
            url: '/Data/User/ProjectManager',
            dataType: 'json'
        },
        parameterMap(data, type) {
            if (type === 'read') {
                data.company = $('[name="Company"]').val()
            }
            console.debug(data);
            return data;
        }
    },
    schema: {
        model: teamMember
    }
});

const linkableItemDataSource = new kendo.data.DataSource({
    transport: {
        read: {
            url: 'LinkableItems',
            dataType: 'json'
        }
    },
    schema: {
        model: linkedItem
    }
});

const platformDataSource = new kendo.data.DataSource({
    transport: {
        read: {
            url: 'Platforms',
            dataType: 'json'
        }
    },
    schema: {
        model: platform
    }
});

const getLinkableData = (typePrefix) => {
    linkableItemDataSource.filter({
        field: 'Category',
        operator: 'eq',
        value: typePrefix
    });
    const filteredItems = linkableItemDataSource.view();
    linkableItemDataSource.filter({});
    return filteredItems;
};

const prfDataSource = new kendo.data.DataSource({
    data: [],
    schema: {
        model: linkedItem
    }
});

const nbDataSource = new kendo.data.DataSource({
    data: [],
    pageSize: 500,
    schema: {
        model: linkedItem
    }
});

const markInvalid = ($element) => {
    if ($element.hasClass('k-textbox') || $element.hasClass('k-input')) $element.addClass('fieldValidationError');
    else $element.parent().addClass('fieldValidationError');
};

const validate = () => {
    $('.fieldValidationError').removeClass('fieldValidationError');
    $('.bg-danger-light').removeClass('bg-danger-light');
    let isValid = doOpportunityValidation();
    isValid = doAttendeeValidation() && isValid;

    const requiredFields = $('[data-required]');
    $.each(requiredFields, function (i, e) {
        const $e = $(e);
        if ($e.val() === undefined || $e.val() === "") {
            isValid = false;
            markInvalid($e);
        }
    });

    return isValid;
};

const doOpportunityValidation = () => {
    const nbItem = $('[name="NorthBoundary.Id"]');
    const prfItem = $('[name="Prf.Id"]');
    const isNbValid = nbItem.val() !== '';
    const isPrfValid = prfItem.val() !== '';
    if (!isNbValid) {
        markInvalid(nbItem);
    }
    if (!isPrfValid) {
        markInvalid(prfItem);
    }

    return isNbValid && isPrfValid;
}
const doAttendeeValidation = () => {
    const attendeeCount = $('.js-attendee-remove').length;
    if (!attendeeCount) {
        $('.js-attendee-list').parent().addClass('bg-danger-light');
    }

    return attendeeCount;
}

const saveForm = (e) => {
    e.preventDefault();
    const isSubmitted = $('[name=IsSubmitted]:checked').val();
    if (isSubmitted === 'true' && !validate()) {
        showErrorNotification('Required fields are missing.')
        return false;
    }
    const form = $('form#estimateApproval')[0];
    const formData = new FormData(form); // use FormData to easily include files
    formData.append('IsSubmitted', isSubmitted);
    $.post({
        url: 'Save',
        data: formData,
        processData: false,
        contentType: false,
        success(d) {
            if (!d.success) {
                showErrorNotification(d.reason);
                return false;
            }
            showSuccessNotification("Estimate Approval submitted!");
            $.redirect({
                url: 'Info',
                values: {Id: d.id}
            });
        }
    });
    return true;
};

const cancelForm = (e) => {
    e.preventDefault();
    $.redirect('Grid');
};

const download = (e) => {
    const db = $('a.js-pdf-download');
    db.prop('disabled', true);
    $.get('DownloadPdf', {bondRequestId: id}, function () {
        db.prop('disabled', false);
    });
};

const createEmployeeSelect = (i, v) => {
    const that = $(v);
    that.kendoAutoComplete({
        dataSource: employeeDataSource,
        filter: 'contains',
        dataTextField: 'DisplayName',
        dataValueField: 'EmpId',
        placeholder: 'Select a team member...',
        noDataTemplate: 'No matching team members found.',
        change(e) {
            const prefix = that.data('for');
            const di = this.dataItem();
            $(`[name="${prefix}\\.EmpId"]`).val(di?.EmpId);
            $(`[name="${prefix}\\.FirstName"]`).val(di?.FirstName);
            $(`[name="${prefix}\\.LastName"]`).val(di?.LastName);
            $(`[name="${prefix}\\.Title"]`).val(di?.Title);
            $(`[name="${prefix}\\.Email"]`).val(di?.Email);
        }
    });
};
const createBranchManagerEmployeeSelect = (i, v) => {
    const that = $(v);
    that.kendoAutoComplete({
        dataSource: branchManagerDataSource,
        filter: 'contains',
        dataTextField: 'DisplayName',
        dataValueField: 'EmpId',
        placeholder: 'Select a team member...',
        noDataTemplate: 'No matching team members found.',
        change(e) {
            const prefix = that.data('for');
            const di = this.dataItem();
            $(`[name="${prefix}\\.EmpId"]`).val(di?.EmpId);
            $(`[name="${prefix}\\.FirstName"]`).val(di?.FirstName);
            $(`[name="${prefix}\\.LastName"]`).val(di?.LastName);
            $(`[name="${prefix}\\.Title"]`).val(di?.Title);
            $(`[name="${prefix}\\.Email"]`).val(di?.Email);
        }
    });
};
const createOpsManagerGsmEmployeeSelect = (i, v) => {
    const that = $(v);
    that.kendoAutoComplete({
        dataSource: opsManagerGsmDataSource,
        filter: 'contains',
        dataTextField: 'DisplayName',
        dataValueField: 'EmpId',
        placeholder: 'Select a team member...',
        noDataTemplate: 'No matching team members found.',
        change(e) {
            const prefix = that.data('for');
            const di = this.dataItem();
            $(`[name="${prefix}\\.EmpId"]`).val(di?.EmpId);
            $(`[name="${prefix}\\.FirstName"]`).val(di?.FirstName);
            $(`[name="${prefix}\\.LastName"]`).val(di?.LastName);
            $(`[name="${prefix}\\.Title"]`).val(di?.Title);
            $(`[name="${prefix}\\.Email"]`).val(di?.Email);
        }
    });
};
const createProjectManagerEmployeeSelect = (i, v) => {
    const that = $(v);
    that.kendoAutoComplete({
        dataSource: projectManagerDataSource,
        filter: 'contains',
        dataTextField: 'DisplayName',
        dataValueField: 'EmpId',
        placeholder: 'Select a team member...',
        noDataTemplate: 'No matching team members found.',
        change(e) {
            const prefix = that.data('for');
            const di = this.dataItem();
            $(`[name="${prefix}\\.EmpId"]`).val(di?.EmpId);
            $(`[name="${prefix}\\.FirstName"]`).val(di?.FirstName);
            $(`[name="${prefix}\\.LastName"]`).val(di?.LastName);
            $(`[name="${prefix}\\.Title"]`).val(di?.Title);
            $(`[name="${prefix}\\.Email"]`).val(di?.Email);
        }
    });
};

const setupLinkDataSources = () => {
    prfDataSource.data(getLinkableData('Prf'));
    nbDataSource.data(getLinkableData('NorthBoundary'));
};

const createLinkSelect = (i, v) => {
    const that = $(v);
    const linkType = that.data('type');
    const dataSource = linkType === 'PRF' ? prfDataSource : nbDataSource;
    if (that.val() <= 0) that.val('');
    that.kendoAutoComplete({
        autoBind: false,
        placeholder: `Select ${linkType}...`,
        filter: 'contains',
        noDataTemplate: `No matching ${linkType} items.`,
        dataTextField: 'Name',
        dataValueField: 'Id',
        dataSource,
        dataBound(args) {
            if (linkType === 'PRF') return;
            if ($('[name="NorthBoundary.Id"]').val() !== '0') return;
            const k_autoAutoComplete = args.sender;
            k_autoAutoComplete.trigger('change');
        },
        async change(e) {
            const isPrf = linkType === 'PRF';
            const prefix = isPrf ? 'Prf' : 'NorthBoundary';
            const di = this.dataItem() || this.dataSource.data().find(element => element.Name === this.value());
            const esp = $(`[name="${prefix}\\.EstimatedSalePrice"]`).data('kendoNumericTextBox');
            const gmp = $(`[name="${prefix}\\.GmPercent"]`).data('kendoNumericTextBox');
            $(`[name="${prefix}\\.Id"]`).val(di?.Id);
            $(`[name="${prefix}\\.Name"]`).val(di?.Name);
            $(`[name="${prefix}\\.Type"]`).val(di?.Type);
            esp.value(di?.EstimatedSalePrice);
            gmp.value(di?.GmPercent);
            if (isPrf) {
                prfId = di?.Id;
                prfType = di?.Type;
                await prfLink();
            }
            return true;
        }
    });
};

const setupEmployeeSelects = async () => {
    try {
        const elements = $('.js-employee-select');
        if (!elements || employeeSelectsInit) return;
        employeeDataSource.fetch();
        elements.each(createEmployeeSelect);
        employeeSelectsInit = true;
    } catch (e) {
        return Promise.reject(e);
    }
    return employeeSelectsInit;
};

const setupBranchManagerEmployeeSelects = async () => {
    try {
        const elements = $('.js-branch-manager-employee-select');
        if (!elements || branchManagerEmployeeSelectsInit) return;
        branchManagerDataSource.fetch();
        elements.each(createBranchManagerEmployeeSelect);
        branchManagerEmployeeSelectsInit = true;
    } catch (e) {
        return Promise.reject(e);
    }
    return branchManagerEmployeeSelectsInit;
};

const setupOpsManagerGsmEmployeeSelects = async () => {
    try {
        const elements = $('.js-ops-manager-gsm-employee-select');
        if (!elements || opsManagerGsmEmployeeSelectsInit) return;
        opsManagerGsmDataSource.fetch();
        elements.each(createOpsManagerGsmEmployeeSelect);
        opsManagerGsmEmployeeSelectsInit = true;
    } catch (e) {
        return Promise.reject(e);
    }
    return opsManagerGsmEmployeeSelectsInit;
};

const setupProjectManagerEmployeeSelects = async () => {
    try {
        const elements = $('.js-project-manager-employee-select');
        if (!elements || projectManagerEmployeeSelectsInit) return;
        projectManagerDataSource.fetch();
        elements.each(createProjectManagerEmployeeSelect);
        projectManagerEmployeeSelectsInit = true;
    } catch (e) {
        return Promise.reject(e);
    }
    return projectManagerEmployeeSelectsInit;
};

const setupLinkedItemSelects = async () => {
    try {
        const elements = $('.js-link-select');
        if (!elements || linkableItemSelectsInit) return;
        linkableItemDataSource.fetch()
            .then(setupLinkDataSources);
        elements.each(createLinkSelect);
        linkableItemSelectsInit = true;
    } catch (e) {
        return Promise.reject(e);
    }
    return linkableItemSelectsInit;
};

const setupDownload = async () => {
    try {
        //disable button
        const db = $('a.js-pdf-download');
        if (db === undefined) return true;
        if (id <= 0) {
            db.hide();
            return true;
        }
        db.on('click', download);
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const platformUsed = async () => {
    try {
        const element = $('[name="PlatformUsed\\.Id"]');
        if (!element) return Promise.reject('Required element does not exist.');
        if (platformUsedInit) return Promise.reject('Platform dropdown already initialized.');
        platformDataSource.fetch();
        element.kendoDropDownList({
            dataSource: platformDataSource,
            dataValueField: 'Id',
            dataTextField: 'Name',
            optionsLabel: 'Select platform...'
        });
        platformUsedInit = true;
    } catch (e) {
        return Promise.reject(e);
    }
    return platformUsedInit;
};

const percentages = async () => {
    try {
        const pf = $('.js-percentage');
        // pf.css('text-align', 'right');
        // pf.kendoNumericTextBox({
        //   format: '### \\%',
        //   spinners: false,
        //   readonly: true
        // });
        pf.each((i, e) => {
            $(e).data('kendoNumericTextBox').readonly();
        });
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const currencies = async () => {
    try {
        const cf = $('.js-currency');
        // cf.css('text-align', 'right');
        // cf.kendoNumericTextBox({
        //   format: 'c0',
        //   spinners: false,
        //   readonly: true
        // });
        cf.each((i, e) => {
            $(e).data('kendoNumericTextBox').readonly();
        });
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const formOptions = async () => {
    try {
        const sub = $('.js-submit');
        const cancel = $('.js-cancel');
        sub.on('click', saveForm);
        cancel.on('click', cancelForm);
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const prfLink = async () => {
    try {
        const $a = $('a.js-prf-link');
        if (prfType === undefined || prfType === '') {
            $a.hide();
            return true;
        }
        $a.show();
        const hrefBase = `/Sales/PursuitRequestForm/${prfType}`;
        const href = prfType === 'Maintenance' ? `${hrefBase}?id=${prfId}` : `${hrefBase}?Id=${prfId}`;
        $a.prop('href', href);
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const displayAttendees = () => {
    console.log("Display Attendees...");
    console.log(attendeeList);
    const attendeeListDisplay = $('.js-attendee-list');
    attendeeListDisplay.empty();
    attendeeList.forEach((value, i) => {
        value.index = i;
        console.log(value);
        const attendeeDisplay = attendeeTemplate(value);
        attendeeListDisplay.append(attendeeDisplay);
    });
}

const attendeeList = [];
const addAttendee = (e) => {
    const attendeeSelect = $('[name="Attendee"]').data('kendoAutoComplete');
    const attendee = attendeeSelect.dataItem();
    if (attendee === undefined) return;
    attendeeList.push(attendee);
    displayAttendees();
    attendeeSelect.value('');
    attendeeSelect.trigger('change');
};

const removeAttendee = (e) => {
    const attendeeId = $(e.currentTarget).parent().data('attendee-id');
    const attendeeIndex = attendeeList.findIndex((value) => value.EmpId === attendeeId);
    attendeeList.splice(attendeeIndex, 1);
    displayAttendees();
};

const attendeeSetup = async () => {
    try {
        attendeeTemplate = kendo.template($('#attendeeTemplate').html());
        const $addAttendee = $('button#AttendeeAdd');
        $addAttendee.on('click', addAttendee);
        const attendeeList = $('.js-attendee-list');
        attendeeList.on('click', '.js-attendee-remove', removeAttendee);

        populateAttendeeList();
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const populateAttendeeList = () => {
    const $savedAttendees = $("[data-employee-info]");

    if (!$savedAttendees.length) return;

    console.log(attendeeList);
    $savedAttendees.each((i, value) => {
        const attendeeInfo = $(value).data("employee-info");
        attendeeList.push(attendeeInfo);
        console.log(attendeeList);
    });

    displayAttendees();
}

const approvalResponse = (response) => {
    if (response.success === true) location.reload();
    else {
        showErrorNotification(response.reason);
    }
};

const submit = (e, action) => {
    const $pin = $('#pin_id');
    const pin = $pin.val();
    const role = $pin.data('role');
    const comment = $('#approval_comment').val();
    const data = {id, role, pin, comment};
    $.post(action, data, approvalResponse);
};

const submitApproval = (e) => {
    submit(e, 'Approve');
};

const submitRejection = (e) => {
    submit(e, 'Reject');
};

const approvalSetup = async () => {
    try {
        if (id <= 0) return true;
        const approvals = $('.js-approve');
        if (approvals !== undefined) approvals.on('click', submitApproval);
        const rejections = $('.js-reject');
        if (rejections !== undefined) rejections.on('click', submitRejection);
        return true;
    } catch (e) {
        return Promise.reject(e);
    }
};

const readyEdit = async () => {
    return await Promise.allSettled([
        setupEmployeeSelects(),
        setupBranchManagerEmployeeSelects(),
        setupOpsManagerGsmEmployeeSelects(),
        setupProjectManagerEmployeeSelects(),
        setupLinkedItemSelects(),
        platformUsed(),
        percentages(),
        currencies(),
        formOptions(),
        prfLink(),
        attendeeSetup(),
        approvalSetup(),
        setupDownload()
    ]);
}

const readyDisplay = async () => {
    return await Promise.allSettled([
        approvalSetup(),
        prfLink(),
        setupDownload()
    ]);
}

export default async function () {
    const form = $('form#estimateApproval');
    const formMode = form.data('mode');

    if (formMode === 'edit') return await readyEdit();
    return await readyDisplay();
}